import { render } from "./DatosContactosVentas.vue?vue&type=template&id=4c508e52"
import script from "./DatosContactosVentas.vue?vue&type=script&lang=js"
export * from "./DatosContactosVentas.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vento-proveedores\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__